/*
 * @Autor: GeekMzy
 * @Date: 2022-04-18 09:40:21
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-04-29 15:44:19
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\router\router.ts
 * @Author: desktop-1llkr2o
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import Main from '@/views/Main.vue'
import Login from '@/components/login.vue'
import SetAuth from '@/components/SetAuth.vue'

const routes = [
  {
    title: '首页',
    path: '/main',
    name: 'main_content',
    component: Main,
    children: [
      {
        title: '首页',
        path: '',
        name: 'main',
        component: () => import('@/views/main/index.vue'),
      },
      {
        title: '流域概况',
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/profile/index.vue'),
      },

      {
        title: '水环境治理',
        path: 'enviroment',
        name: 'enviroment',
        component: () => import('@/views/enviroment/index.vue'),
      },
      {
        title: '水污染防治',
        path: 'pollution',
        name: 'pollution',
        component: () => import('@/views/pollution/index.vue'),
      },
      {
        title: '指挥调度',
        path: 'dispatch',
        name: 'dispatch',
        component: () => import('@/views/dispatch/index.vue'),
      },
      {
        title: '入河排口',
        path: 'outfall',
        name: 'outfall',
        component: () => import('@/views/outfall/index.vue'),
      },
    ],
  },
  {
    title: '登录',
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    title: '权限验证',
    path: '/setAuth',
    name: 'setAuth',
    component: SetAuth,
  },
  {
    path: "/",
    name: "",
    redirect: "/login",
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export { routes, router }
